/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { PriceComponent } from '@msdyn365-commerce/components';
import { IImageSettings, Image } from '@msdyn365-commerce/core';
// import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';
class CartLineItem extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
    }

    private readonly addProductLink = (product: any, snapShotId: string, lineId: string, actionContext: any) => {
        const productUrl = getProductUrlSync(product, actionContext, undefined);
        return (
            productUrl +
            (productUrl.indexOf('?') === -1
                ? `?cartLineItemSnapShotId=${snapShotId}&lineId=${lineId}`
                : `cartLineItemSnapShotId=${snapShotId}&lineId=${lineId}`)
        );
    };

    public render(): JSX.Element | null {
        const _renderPrice = (props: any, ring: any): JSX.Element | null => {
            const { context } = props;
            if (ring.price) {
                return (
                    <PriceComponent
                        id={'aaa_cart'}
                        typeName={'aaa_cart'}
                        data={ring}
                        freePriceText={'free'}
                        originalPriceText={'original price'}
                        currentPriceText={'current price'}
                        context={context}
                    />
                );
            }
            return null;
        };

        const defaultImageSettings: IImageSettings = {
            viewports: {
                xs: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
                lg: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
                xl: { q: 'w=100&h=100&m=6', w: 100, h: 100 }
            },
            lazyload: true,
            cropFocalRegion: true
        };
        const rounded = (ringSize?: number) => {
            if (ringSize) {
                return ringSize.toFixed(2);
            }
            return '';
        };
        const props = this.props.allProps;
        return (
            <>
                {this.props.cartLine && this.props.productInfo && !this.props.isLoading ? (
                    <div className={'row aaa-cart-wrapper aaa-my-order'}>
                        <div className={'col-auto col-sm-auto col-md-12 col-lg-12'}>
                            <>
                                <div className={'aaa-cart-left-section'}>
                                    <div className={'col-auto col-sm-auto col-md-12 col-lg-3'}>
                                        <button
                                            className='ms-wishlist-items__product-remove-button cart-remove-icon'
                                            aria-label={'Remove from Cart'}
                                            onClick={() => props.removeItemClickHandler(this.props.cartLine)}
                                        />
                                        <Image
                                            requestContext={props.context.actionContext.requestContext}
                                            altText={this.props.productInfo.Name}
                                            className='ms-wishlist-items__product-image'
                                            title={this.props.productInfo.Name}
                                            src={this.props.cartLineImageUrl}
                                            fallBackSrc={this.props.cartLineImageUrl}
                                            gridSettings={props.context.request.gridSettings!}
                                            imageSettings={defaultImageSettings}
                                            loadFailureBehavior={'empty'}
                                        />
                                        <Button
                                            className='ms-wishlist-items__product-add-button customise-button'
                                            title={'Customise'}
                                            href={this.addProductLink(
                                                this.props.productInfo,
                                                this.props.snapShotId,
                                                this.props.cartLine.LineNumber,
                                                props.context.actionContext
                                            )}
                                        >
                                            {'Edit'}
                                        </Button>
                                    </div>
                                    <div className={'col-auto col-sm-auto col-md-10 col-lg-9 aaa-cart-detail'} style={{ paddingTop: 0 }}>
                                        <div className={'aaa-cart-heading'}>
                                            <span>{this.props.productInfo.Name}</span>
                                            <span className={'snap-shot-id'}>
                                                <strong>Snapshot Id : </strong>
                                                {this.props.snapShotId}
                                            </span>
                                        </div>
                                        <div className={'aaa-cart-row'}>
                                            <span className={'aaa-cart-row-column aaa-customer-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>Customer</span>
                                                {this.props.customerInfo ? (
                                                    <span className={'aaa-cart-row-column-text'}>
                                                        {this.props.customerInfo.b2cCustomerName}
                                                        <br />
                                                        {this.props.customerInfo.b2cEmailId}
                                                        <br />
                                                        {this.props.customerInfo.b2cPhone}
                                                    </span>
                                                ) : (
                                                    <span className={'aaa-cart-row-column-text'}>
                                                        <input
                                                            className='msc-promo-code__input-box customer-input'
                                                            onChange={e =>
                                                                props.customerInputHandler(
                                                                    'name',
                                                                    this.props.cartLine,
                                                                    e.target.value,
                                                                    this.props.index
                                                                )
                                                            }
                                                            value={this.props.customerInfoInput.customerName}
                                                            placeholder={'Enter Name'}
                                                        />
                                                        <input
                                                            className='msc-promo-code__input-box customer-input'
                                                            onChange={e =>
                                                                props.customerInputHandler(
                                                                    'email',
                                                                    this.props.cartLine,
                                                                    e.target.value,
                                                                    this.props.index
                                                                )
                                                            }
                                                            value={this.props.customerInfoInput.customerEmail}
                                                            placeholder={'Enter Email'}
                                                        />
                                                        <input
                                                            className='msc-promo-code__input-box customer-input aaa-input-number'
                                                            onChange={e =>
                                                                props.customerInputHandler(
                                                                    'phone',
                                                                    this.props.cartLine,
                                                                    e.target.value,
                                                                    this.props.index
                                                                )
                                                            }
                                                            value={this.props.customerInfoInput.customerPhone}
                                                            placeholder={'Enter Phone'}
                                                        />
                                                    </span>
                                                )}
                                            </span>
                                            <span className={'aaa-cart-row-column aaa-comment-column'}>
                                                <span className={'aaa-cart-row-column-heading'} style={{ margin: '0px 5px' }}>
                                                    Comments
                                                </span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    <textarea
                                                        className='msc-promo-code__input-box comment-box'
                                                        onChange={e =>
                                                            props.commentInputHandler(this.props.cartLine, e.target.value, this.props.index)
                                                        }
                                                        value={this.props.cartLineComment}
                                                        placeholder={'Enter Message'}
                                                    />
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column required-date'}>
                                                <span className={'aaa-cart-row-column-heading'}>ETA</span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    <input
                                                        // className='msc-promo-code__input-box customer-input aaa-input-number'
                                                        value={moment(this.props.cartLineRequestDate).format('DD-MM-YYYY')}
                                                        disabled={true}
                                                    />
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column cart-quantity'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Quantity'}</span>
                                                <span className={'aaa-cart-row-column-text'}>1</span>
                                            </span>
                                        </div>
                                        {this.props.itemInfo.rings &&
                                            this.props.itemInfo.rings.map((ring: any) => {
                                                return (
                                                    <div className={'aaa-cart-row'} key={ring.ringId}>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{ring.ringName}</span>
                                                            <div className={'aaa-cart-row-column-text'}>
                                                                Colors : {ring.ringFinenessColorPolishInfo.length}
                                                            </div>
                                                            <div>
                                                                {ring.ringFinenessColorPolishInfo.map((r: any, index: number) => {
                                                                    return (
                                                                        <div key={index} className={'aaa-cart-row-column-text'}>
                                                                            {r}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </span>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Size'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>
                                                                Size {ring.sizeLabel} ( &Oslash; {rounded(ring.sizeValue)}mm)
                                                            </span>
                                                        </span>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Specification'}</span>
                                                            <div className={'aaa-cart-row-column-text'}>{ring.specifications}</div>
                                                            {ring.engraving !== '' && (
                                                                <div className={'aaa-cart-row-column-text'}>Engraving</div>
                                                            )}
                                                        </span>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Price'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>{_renderPrice(props, ring)}</span>
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        <div className={'aaa-cart-final-price'}>
                                            <span className={'aaa-cart-total-label'}>Total incl. GST</span>{' '}
                                            {_renderPrice(props, this.props.itemInfo)}
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                ) : (
                    <div className={'row aaa-cart-wrapper'}>Loading...</div>
                )}
            </>
        );
    }
}
export default CartLineItem;
